import { GoHome } from "react-icons/go";
import { Link } from "react-router-dom";
import { GoGraph } from "react-icons/go";
import { PiMoneyWavy } from "react-icons/pi";
import { CiShoppingCart } from "react-icons/ci";
import { CiViewList } from "react-icons/ci";
import { MdOutlineInventory2 } from "react-icons/md";
import { CiShop } from "react-icons/ci";
import { GrHelpBook } from "react-icons/gr";
// import { Text, View } from 'react-native';

// src/components/About.jsx
function BottomBar() {
    return (
      <div style={styles.BottomBar}>
        <Link>
          <GoHome />
        </Link>
        <Link>
          <PiMoneyWavy />
        </Link>
        <Link>
          <GoGraph />
        </Link>
        <Link>
          <CiShoppingCart />
        </Link>
        <Link>
          <CiViewList />
        </Link>
        <Link>
          <MdOutlineInventory2 />
        </Link>
        <Link>
          <CiShop />
        </Link>
        <Link>
          <GrHelpBook />
        </Link>
      </div>
    );
  }

  const styles = {
    BottomBar : {
        textAlign: "center",
        marginTop: "2rem",
        padding: "1rem",
        backgroundColor: "#f0f0f0",
        borderRadius: 4,
        position:"fixed",
        zIndex: 9999,
        bottom:0,
        left:0,
        width:"100%",
    }
  }
  
  export default BottomBar;